/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HealthGoalResponseDto
 */
export interface HealthGoalResponseDto {
    /**
     * One of the top 3 things the user would like to change about their health
     * @type {string}
     * @memberof HealthGoalResponseDto
     */
    text: string;
    /**
     * Unique identifier for the health goal
     * @type {string}
     * @memberof HealthGoalResponseDto
     */
    id: string;
}

/**
 * Check if a given object implements the HealthGoalResponseDto interface.
 */
export function instanceOfHealthGoalResponseDto(value: object): value is HealthGoalResponseDto {
    if (!('text' in value) || value['text'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function HealthGoalResponseDtoFromJSON(json: any): HealthGoalResponseDto {
    return HealthGoalResponseDtoFromJSONTyped(json, false);
}

export function HealthGoalResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): HealthGoalResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'text': json['text'],
        'id': json['id'],
    };
}

export function HealthGoalResponseDtoToJSON(json: any): HealthGoalResponseDto {
    return HealthGoalResponseDtoToJSONTyped(json, false);
}

export function HealthGoalResponseDtoToJSONTyped(value?: HealthGoalResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'text': value['text'],
        'id': value['id'],
    };
}

